import { render, staticRenderFns } from "./organization-invite-survey-member.vue?vue&type=template&id=bb8be0e8"
import script from "./organization-invite-survey-member.vue?vue&type=script&lang=js"
export * from "./organization-invite-survey-member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports